import { endpoints } from '../endpoints';
import { httpClient } from '../../lib/http-client';
import { planetsResponseSchema, planetSchema, type Planet } from '../../schemas/planet';

/**
 * Fetches a list of all available planets.
 */
export async function fetchPlanets(): Promise<Planet[]> {
  const { data } = await httpClient.get(endpoints.planet.list);
  const parsed = planetsResponseSchema.parse(data);
  return parsed.planets;
}

/**
 * Fetches the details of a specific planet by its ID.
 */
export async function fetchPlanet(id: string): Promise<Planet> {
  const { data } = await httpClient.get(endpoints.planet.detail(id));
  // The API may return { planet: {...} } or the object directly
  return planetSchema.parse(data.planet ?? data);
}
